export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function formatTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatWindow(from, to) {
  if (!from && !to) return null;
  if (from && to) {
    const d1 = new Date(from);
    const d2 = new Date(to);
    const sameDay =
      d1.toDateString() === d2.toDateString() && !Number.isNaN(d1.getTime());
    if (sameDay) {
      return `${formatDate(from)} · ${formatTime(from)} – ${formatTime(to)}`;
    }
    return `${formatDateTime(from)} – ${formatDateTime(to)}`;
  }
  return formatDateTime(from || to);
}
